// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__vjMEH","button":"Toggle_button__GiAiL","selected":"Toggle_selected__4HsLc"};